import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  showSidebar: boolean = true;
  mobileSidebar: boolean = false;
  screenWidth: number;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.mobileSidebar = this.document.documentElement.clientWidth <= 992 ? true : false;
  }

  constructor(
    private router: Router, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
   this.showSidebar = this.router.url.includes('login') ? false : true
   this.mobileSidebar = this.document.documentElement.clientWidth <= 992 ? true : false;
  }

  toggleSidebar(){
    this.mobileSidebar = !this.mobileSidebar;
  }

}
